/**
 * Nomes que pertencem a plataforma e nunca a uma imobiliaria.
 *
 * A mesma lista serve para duas perguntas diferentes:
 *
 * - o primeiro segmento do caminho e um slug ou uma rota da plataforma?
 *   (`/explore` nao e imobiliaria, `/imobx` e)
 * - o primeiro rotulo do host e um slug ou um endereco da plataforma?
 *   (`api.seulugar.imb.br` nao e imobiliaria, `imobx.seulugar.imb.br` e)
 *
 * Vive em arquivo proprio porque `index.ts` e `host.ts` precisam dela e um
 * importa o outro — deixa-la em qualquer um dos dois criaria ciclo.
 *
 * Precisa espelhar `TenantSlugResolver.RESERVED_SLUGS` no back-end, que usa a
 * mesma lista para impedir o cadastro de um slug que sequestraria uma rota ou
 * um endereco existente.
 */

/** Endereco da landing page e do cadastro de imobiliaria. */
export const LANDING_LABEL = 'lp'

/** Endereco curto que leva o cliente ao painel da sua imobiliaria. */
export const CLIENT_GATEWAY_LABEL = 'cliente'

const RESERVED = new Set([
  // Rotas de topo do site
  'admin',
  'portal',
  'login',
  'logout',
  'explore',
  'favorites',
  'property',
  'announce',
  'cadastro',
  'know-us',
  'terms',
  'privacy',
  'p',
  'sign',
  'upload',
  'para-imobiliarias',
  'change-password',
  'onboarding',
  'imobiliaria',
  // Hosts da plataforma
  LANDING_LABEL,
  CLIENT_GATEWAY_LABEL,
  'api',
  'app',
  'www',
  'mail',
  'webmail',
  'smtp',
  'ftp',
  'ns1',
  'ns2',
  'cdn',
  'autoconfig',
  'autodiscover',
  'cpanel',
  'cpcalendars',
  'cpcontacts',
  'keycloak',
  'blog',
  'dev',
  'homolog',
  'qas',
  // Infraestrutura
  'static',
  'assets',
  'public',
  'stage',
  'health',
  'actuator'
])

export const RESERVED_SEGMENTS = RESERVED

export function isReservedSegment(segment: string): boolean {
  return RESERVED.has(segment.toLowerCase())
}
